import React from "react";
import {useNavigate} from "react-router-dom";
import {ASSET_CONTRACT_HEADER} from "../../../../components/table/header/Headers";
import {getContractList} from "../../../../api/asset/AssetContractService";
import useRequestData from "../../../../hooks/useRequestData";
import SearchSection from "../../../../components/search/SearchSection";
import {SearchComboBox} from "../../../../components/select/SearchComboBox";
import Selector from "../../../../components/selector/Selector";
import {searchListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Search from "../../../../components/search/Search";
import {
    contractClassification,
    contractEndOfDate,
    contractType,
    type,
} from "../../finance/contract/subPages/AssetContractListType";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import {extractObject, nonObject} from "../../../../components/commonmethod/CommonMethod";
import DetailLinkedListView from "../../../../components/detailLayout/DetailLinkedListView";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";

function AssetContract({id}) {
    const navigate = useNavigate();
    const {newData, pageInfo, dataHook} = useRequestData((conditions, pageable) => {
        const additionalCondition = {
            entityId: id,
            dateType: conditions.dateType || "등록일",
        };
        const finalConditions = {
            ...conditions,
            ...additionalCondition,
        };
        return getContractList(finalConditions, pageable, "asset_info_contract");
    }, {});

    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;

    const handleRowClick = (row) => {
        const rowId = row?.id;
        if (rowId == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "계약 상세"),
            url: `/asset/contract/${rowId}`,
        });
    };

    return (
        <DetailLinkedListView
            headerDefinition={ASSET_CONTRACT_HEADER}
            settingKey="contract"
            newData={newData}
            onPageChange={handleGridPageChange}
            onRowClick={handleRowClick}
        >
            <Search
                entity={"contract"}
                refresh={refresh}
                searchConditions={saveConditions}
                handleSearch={handleSearch}
                handlePageSizeChange={handlePageSizeChange}
                pageInfo={pageInfo}
                size
                detail
                searchBar={{placeHolder: "계약명, 계약번호, 계약종류, 구분"}}
            >
                <SearchSection>
                    <SearchComboBox
                        title={"날짜조건"}
                        code={type}
                        target={"dateType"}
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "dateType")}
                    />
                    <SearchComboBox
                        title={"계약구분"}
                        code={contractType}
                        target={"contractType"}
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "contractType")}
                    />
                    <SearchComboBox
                        title={"계약종류"}
                        code={contractClassification}
                        target={"contractClassification"}
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "contractClassification")}
                    />
                    <SearchComboBox
                        title={"계약 기간만료"}
                        code={contractEndOfDate}
                        target={"type"}
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "type")}
                    />
                    <Selector
                        showLabel
                        onChange={(value) => searchListener(handleSearch, "company", extractObject(saveConditions), value)}
                        data={saveConditions.company}
                        entity={"company"}
                        title={"업체"}
                    >
                        <SimmsInputSearch type={"TEXT"} placeHolder={"업체명"} />
                    </Selector>
                </SearchSection>
            </Search>
        </DetailLinkedListView>
    );
}

export default AssetContract;
